export type PluginConfig = {
  enabled: boolean;
  name: string;
  icon: string;
  route: string;
  backend: boolean;
  permissions?: string[];
  dependencies?: string[];
  description?: string;
  version?: string;
  publicAccess?: boolean;
};

// Charlie feature plugins
export const PLUGIN_REGISTRY: Record<string, PluginConfig> = {
  charlieHome: {
    enabled: true,
    name: "Home",
    icon: "Home",
    route: "/home",
    backend: false,
    description: "Charlie home dashboard with quick actions",
  },
  charlieChat: {
    enabled: true,
    name: "Chat",
    icon: "MessageCircle",
    route: "/chat",
    backend: false,
    description: "Charlie AI concussion chat assistant",
  },
  sidelineAssessment: {
    enabled: true,
    name: "Assessment",
    icon: "ShieldAlert",
    route: "/assessment",
    backend: false,
    publicAccess: true,
    description: "CRT6-based sideline concussion assessment",
  },
  knowledge: {
    enabled: true,
    name: "Knowledge Base",
    icon: "Brain",
    route: "/knowledge",
    backend: true,
    description: "AI-powered document management and chat",
    permissions: ["knowledge:read", "knowledge:write"],
    version: "1.0.0",
    dependencies: ["database", "auth", "ai-services"],
  },
} as const;

// Helper functions
export const getEnabledPlugins = (): string[] => {
  return Object.entries(PLUGIN_REGISTRY)
    .filter(([_, config]) => config.enabled)
    .map(([name, _]) => name);
};

export const getPluginConfig = (
  pluginName: string
): PluginConfig | undefined => {
  return PLUGIN_REGISTRY[pluginName];
};

export const isPluginEnabled = (pluginName: string): boolean => {
  return PLUGIN_REGISTRY[pluginName]?.enabled ?? false;
};

export const getAllPlugins = (): Record<string, PluginConfig> => {
  return PLUGIN_REGISTRY;
};

export const getEnabledPluginConfigs = (): Record<string, PluginConfig> => {
  return Object.fromEntries(
    Object.entries(PLUGIN_REGISTRY).filter(([_, config]) => config.enabled)
  );
};
